import axios from "axios";
import {
    ADD_APPLICANT_COMMENT,
    APPLICANT_FILES,
    APPLICANT_SEARCH,
    GET_APPLICANT_DATA_BY_EMAIL,
    GET_APPLICANT_DATA_BY_ID,
    SHORT_LIST_CANDIDATE_POST,
    SCREENING_SCHEDULE,
    CREDITS,
    AVAILABLE_CREDITS,
    PUBLIC_APPLICATION_LINK,
    VETTING,
    SEND_TO_DIRECTOR,
    SCREENING_CHECKLIST
} from "@/app/Config/ScreeningAppUrl";
import {axiosPost} from "@/app/Helpers/AxiosHelper";

export const Search = {
    getApplicantSearch: (candidateId) => axios.get(`${APPLICANT_SEARCH + candidateId}`),
    saveScreeningSearch: (candidateId, body) => axios.post(`${APPLICANT_SEARCH + candidateId}`, body)
}

export const File = {
    uploadDocument: (formData) => axiosPost(`${APPLICANT_FILES}`, formData),
    deleteDocument: (applicantFileId) => axios.delete(`${APPLICANT_FILES}/${applicantFileId}`)
}

export const Candidate = {
    shortListCandidate: (applicantId) => axiosPost(`${SHORT_LIST_CANDIDATE_POST}/${applicantId}`, {}),
    getCandidateByEmail: (email) => axios.get(`${GET_APPLICANT_DATA_BY_EMAIL + email}`),
    getCandidateById: (candidateId, applicantArchiveId = null) => axios.get(`${GET_APPLICANT_DATA_BY_ID + candidateId}&applicantArchiveId=${applicantArchiveId}`),
    getScreeningSchedule: () => axios.get(`${SCREENING_SCHEDULE}`),
    postScreeningSchedule: (body) => axiosPost(`${SCREENING_SCHEDULE}`, body),
    postVetting: (id, body) => axiosPost(`${VETTING}/${id}`, body),
    postScreeningChecklist: (applicantId, body) => axiosPost(`${SCREENING_CHECKLIST}/${applicantId}`, body),
}

export const Comment = {
    saveComment: (applicantId, commentObj) => axiosPost(`${ADD_APPLICANT_COMMENT}/${applicantId}`, commentObj),
    editComment: (applicantId, commentId, commentObj) => axiosPost(`${ADD_APPLICANT_COMMENT}/${applicantId}/${commentId}`, commentObj)
}

export const Credits = {
    getCredits: () => axios.get(`${CREDITS}`),
    getAvailableCredits: () => axios.get(`${AVAILABLE_CREDITS}`),
    postCredit: (request) => axiosPost(`${CREDITS}`, request)
}

export const NewApplication = {
    getPublicAppLink: () => axios.get(`${PUBLIC_APPLICATION_LINK}`),

}